import { render, staticRenderFns } from "./switchback.vue?vue&type=template&id=c28b6074&scoped=true&"
import script from "./switchback.vue?vue&type=script&lang=js&"
export * from "./switchback.vue?vue&type=script&lang=js&"
import style0 from "./switchback.vue?vue&type=style&index=0&id=c28b6074&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28b6074",
  null
  
)

export default component.exports